import { api } from '../api';

type RequestResetResponse = string;

interface RequestResetRequest {
  email: string;
  recaptchaToken?: string;
}

const requestReset = async ({ email, recaptchaToken }: RequestResetRequest) =>
  api.post<RequestResetResponse>('/password.requestReset', { email }, { 'G-Recaptcha-Response': recaptchaToken });

export default requestReset;
